import TicketTypeIcon from "app/components/TicketTypeIcon";
import React from "react";
import { ITicketTypes } from "../../WorkItems/types";

interface Props {
  ticketType: ITicketTypes[];
  associatedTicketTypes: string[];
  maxVisible?: number;
}
const RenderTicketTypes: React.FC<Props> = ({
  ticketType,
  associatedTicketTypes,
  maxVisible = 5,
}) => {
  const MAX_VISIBLE = maxVisible;
  const length = associatedTicketTypes.length;

  // Slice the array to show only the first 5 items
  const visibleTypes = ticketType.slice(0, MAX_VISIBLE);
  const remainingCount = length - MAX_VISIBLE;

  return (
    <div className="flex items-center flex-wrap gap-1">
      {/* 1. Render the first 5 tags */}
      {visibleTypes.map((type) => (
        <div
          key={type._id}
          className="px-1.5 py-1 bg-[#F1F2F4] rounded flex items-center gap-1"
        >
          <TicketTypeIcon iconName={type.icon} size={12} />
          <span className="text-xs text-black font-normal">{type.name}</span>
        </div>
      ))}

      {/* 2. Render the +N badge if there are more items */}
      {remainingCount > 0 && (
        <div className="px-1.5 py-1 bg-black rounded flex items-center justify-center ">
          <span className="text-xs text-white font-normal">
            +{remainingCount}
          </span>
        </div>
      )}
    </div>
  );
};

export default RenderTicketTypes;
